import { useEffect } from "react";
import "../css/userProfile.css";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getProfileChurchData,
  resetChurchProfile,
  setViewChurchFeedbackModal,
} from "../features/profileChurch/profileChurchSlice";
import NotAMember from "../components/userProfile/NotAMember";
import ReportPostModal2 from "../components/modals/ReportPostModal2";
import ChurchProfileTopInfo from "../components/userProfile/ChurchProfileTopInfo";
import Events from "components/events/Events";
import Polls from "./polls/Polls";
import Bulletin from "./bulletin/Bulletin";
import Anouncements from "./anouncements/Anouncements";
import Directory from "./directory/Directory";
import {
  logoutUserFaraSesiune,
  resetUserForLogout,
} from "features/auth/authSlice";
import About from "components/aboutChurch/About";
import ChurchLinks from "components/links/ChurchLinks";
import Posts from "components/posts/Posts";
import Sidebar from "components/Sidebar";
import ExtraSidebar from "components/sidebar/Sidebar";
import {
  PageWrapper,
  PageContainerMain,
  UserProfileMain,
  StyledSideBar,
} from "./pages.styled";
import Videos from "components/videos/Videos";
import Files from "components/files/Files";
import { setAdmin, setModerator } from "features/auth/authSlice";
import { Modal } from "@mui/material";
import ChurchFeedbackModal from "components/churchFeedback/ChurchFeedbackModal";
import MediaPage from "components/media/Media";
import Giving from "components/giving/Giving";
import QASessions from "components/qaSessions/QASessions";
import { isChurchFeatureEnabled } from "utils/churchFeatures";

import SpinnerSmall from "components/SpinnerSmall";
import { useTranslation } from "react-i18next";

export default function UserProfileChurch() {
  const { t } = useTranslation("church");
  let { churchName } = useParams();

  const location = useLocation();
  const section = new URLSearchParams(location.search).get("section")
    ? new URLSearchParams(location.search).get("section")
    : "none";
  const activeProfileSection = section === "qaSessions" ? "sessions" : section;
  // const folder = new URLSearchParams(location.search).get('folder') ? new URLSearchParams(location.search).get('folder') : 'none'

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const {
    profileChurch,
    isChurchProfileError,
    isChurchProfileSuccess,
    isChurchProfileLoading,
    churchMessage,
  } = useSelector((state) => state.profileChurch);
  const { viewModal } = useSelector((state) => state.modal);
  const { viewSideBar } = useSelector((state) => state.sidebar);

  const { viewChurchFeedbackModal } = useSelector(
    (state) => state.profileChurch,
  );

  useEffect(() => {
    sessionStorage.setItem("cpk", profileChurch.stripeId);
  }, [profileChurch]);

  useEffect(() => {
    if (!user) {
      navigate(`/church/${churchName}`);
    }
  }, [user, navigate, churchName]);

  useEffect(() => {}, [section]);

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  // bug here.. October 2023. When a user visits another church profile. A user can no longer navigate to their church from the left pane.
  // useEffect(() => {
  //     return () => {
  //       if(profileChurch) {
  //           dispatch(resetChurchProfile())
  //       }
  //     }
  //   }, [])

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

  useEffect(() => {
    if (user) {
      if (profileChurch.length === 0 && !isChurchProfileLoading) {
        //if there's no profile
        dispatch(
          getProfileChurchData({
            //userIdX: user._id, //<== this is g4ewabeing sent as undefined
            profileName: churchName,
          }),
        );
      } else {
        // if there is a profile but it is a different one, then get the new profile
        if (
          profileChurch &&
          profileChurch.username !== churchName &&
          !isChurchProfileLoading
        ) {
          dispatch(resetChurchProfile());

          dispatch(
            getProfileChurchData({
              profileName: churchName,
            }),
          );
        }
      }
    }

    // }, [user, isChurchProfileLoading, churchName, profileChurch])
  }, []);

  useEffect(() => {
    if (isChurchProfileError) {
      if (churchMessage === "Not logged in") {
        dispatch(logoutUserFaraSesiune());
        dispatch(resetUserForLogout());
        navigate("/login");
        // window.location.reload()
      } else if (churchMessage === "No profile found") {
        // here we should have a 404  page

        if (user.isChurch || user.isOrganization) {
          navigate(`/${user.name}`);
        } else {
          navigate("/");
        }
      }
    }
  }, [isChurchProfileError, churchMessage, dispatch, navigate]);

  useEffect(() => {
    if (
      isChurchProfileSuccess &&
      profileChurch?.isViewable &&
      !isChurchFeatureEnabled(
        profileChurch?.churchFeatures,
        activeProfileSection,
      )
    ) {
      navigate(`/${churchName}?section=posts`, { replace: true });
    }
  }, [
    activeProfileSection,
    churchName,
    isChurchProfileSuccess,
    navigate,
    profileChurch,
  ]);

  useEffect(() => {
    if (profileChurch && profileChurch.isViewable) {
      if (user) {
        let lr = JSON.parse(localStorage.getItem("pr"));

        if (
          isChurchProfileSuccess &&
          profileChurch &&
          profileChurch.username === churchName
        ) {
          //  this works for someone being added as an admin or moderator or who is already an admin or moderator
          // however, if the user is removed as an admin or moderator, the state will not be updated immediately for the user until after a new page session
          // since it is stored in session storage, i don't believe this is such a big deal, but it is something to be aware of

          if (profileChurch.admins.includes(user._id)) {
            dispatch(
              setAdmin({
                id: profileChurch._id,
                value: true,
              }),
            );
          } else if (profileChurch.moderators.includes(user._id)) {
            dispatch(
              setModerator({
                id: profileChurch._id,
                value: true,
              }),
            );
          }
        }
      }
    }
  }, [isChurchProfileSuccess, profileChurch, user, dispatch, churchName]);

  if (isChurchProfileLoading) {
    return <SpinnerSmall border="#797979" />;
  }

  return (
    <PageWrapper>
      <PageContainerMain fullWidth={viewSideBar !== "none"}>
        <Sidebar />
        {isChurchProfileLoading ? (
          <SpinnerSmall border="#797979" />
        ) : (
          isChurchProfileSuccess &&
          (profileChurch ? (
            profileChurch.isViewable ? (
              <>
                <UserProfileMain fullWidth={viewSideBar !== "none"}>
                  <ChurchProfileTopInfo />

                  {activeProfileSection === "posts" ||
                  activeProfileSection === "none" ? (
                    <Posts church={true} />
                  ) : activeProfileSection === "events" ? (
                    <Events />
                  ) : activeProfileSection === "directory" ? (
                    <Directory />
                  ) : activeProfileSection === "announcements" ? (
                    <Anouncements />
                  ) : activeProfileSection === "bulletin" ? (
                    <Bulletin />
                  ) : activeProfileSection === "polls" ? (
                    <Polls />
                  ) : activeProfileSection === "about" ? (
                    <About />
                  ) : activeProfileSection === "media" ? (
                    <MediaPage />
                  ) : activeProfileSection === "videos" ? (
                    <Videos />
                  ) : activeProfileSection === "files" ? (
                    <Files />
                  ) : activeProfileSection === "sessions" ? (
                    <QASessions />
                  ) : activeProfileSection === "giving" ? (
                    <Giving />
                  ) : (
                    activeProfileSection === "links" && <ChurchLinks />
                  )}
                </UserProfileMain>
                <StyledSideBar>
                  <ExtraSidebar />
                </StyledSideBar>
              </>
            ) : (
              <NotAMember />
            )
          ) : (
            <div>{t("errors.notChurch")}</div>
          ))
        )}

        {viewModal === true && <ReportPostModal2 />}
      </PageContainerMain>

      <Modal
        open={viewChurchFeedbackModal}
        onClose={() => dispatch(setViewChurchFeedbackModal(false))}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div
          style={{
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <ChurchFeedbackModal />
        </div>
      </Modal>
    </PageWrapper>
  );
}
